<template>
  <div v-if="isOrderByStatus" class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content" @click.self="close">
    <div class="relative w-full lg:w-[83%] max-h-screen bg-[#f8f8f8] p-[40px] overflow-auto">
      <button class="absolute right-12 top-12 cursor-pointer z-10" type="button" @click="close">
        <span class="mdi text-xl mdi-close"></span>
      </button>
      <div class="w-full pb-2 flex flex-col justify-start items-start gap-[15px]">
        <h2 class="text-[#353535] text-[20px] leading-[28px] font-semibold">
          Viewing Orders Report: Total Orders By Status
        </h2>
        <div
          class="flex xs:flex-col xl:flex-row xs:justify-start xl:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 xl:items-center">
          <p class="text-[#353535] text-[14px] leading-[20px] font-medium">
            All orders by status reports this year
          </p>
          <div class="flex gap-1 sm:gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center">
            <button @click="viewFilter"
              class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none">
              <span class="">
                <img src="/assets/icon/sort.svg" alt="" />
              </span>
              Filters
            </button>
            <button @click="csvExport(csvData)"
              class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none">
              <span class="">
                <img src="/assets/icon/export.svg" alt="" />
              </span>
              Export Data
            </button>
            <button
              class="border-[1px] bg-[#7367f0] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none"
              @click="exportAllData" :disabled="isExportAllLoading">
              <span v-if="isExportAllLoading" class="fa-solid fa-spinner fa-spin"></span>
              <span v-else class="feather icon-download text-white"></span>
              {{ isExportAllLoading ? "Loading..." : "Export All" }}
            </button>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table p-0 m-0 dataTable no-footer text-nowrap">
          <thead>
            <tr>
              <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                Distributor Code
              </th>
              <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                Distributor Name
              </th>
              <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                Orders Sum
              </th>
              <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                Orders Count (Canceled)
              </th>
              <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                Orders Count (Awaiting Approval)
              </th>
              <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                Orders Count (Processed)
              </th>
              <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                Orders Amount (Canceled)
              </th>
              <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                Orders Amount (Awaiting Approval)
              </th>
              <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">
                Orders Amount (Processed)
              </th>
            </tr>
          </thead>
          <tbody class="bg-white">
            <tr v-if="loading">
              <td colspan="12" class="text-center">
                <div class="text-center" style="padding-top: 100px; padding-bottom: 50px">
                  <span class="fa-solid fa-spinner fa-spin text-[#2463EB]" style="font-size: 8rem"></span>
                  <h3 class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                    style="padding-bottom: 100px">
                    Please wait
                  </h3>
                </div>
              </td>
            </tr>
            <tr v-for="item in ReportItems" :key="item.rowNum" v-else>
              <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                {{ item.distributorCode }}
              </td>
              <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                {{ item.distributorName }}
              </td>
              <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                {{ formatMoney(item.orderAmountSum) }}
              </td>
              <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                {{ item.orderCanceledCount }}
              </td>
              <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                {{ item.orderPendingCount }}
              </td>
              <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                {{ item.orderFulfilledCount }}
              </td>
              <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                {{ formatMoney(item.orderCanceledAmount) }}
              </td>
              <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                {{ formatMoney(item.orderPendingAmount) }}
              </td>
              <td class="text-[14px] font-normal leading-[16.94px] text-[#353535]">
                {{ formatMoney(item.orderFulfilledAmount) }}
              </td>
            </tr>
            <tr v-if="!ReportItems.length && !loading">
              <td colspan="12">
                <div class="text-center">No matching records</div>
              </td>
            </tr>
          </tbody>
        </table>
        <Pagination :limit="pageSize" :count="pageCount" :page="page" :itemsCount="count" @changePage="gotoPage"
          @changeLimit="changeLimit" />
      </div>
    </div>
    <div class="modal fade py-1" id="mod-filter" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4 class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]">
              Filter
            </h4>
            <button class="text-2xl text-[#353535]" type="button" data-dismiss="modal" aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="mb-[16px]">
              <label class="text-[#353535] font-bold-500 text-[14px] leading-[20px]">Start Date</label>
              <div>
                <input type="date" :max="maxDate" placeholder="Select a date" v-model="filter.dateStart"
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none focus:outline-none" />
              </div>
              <div class="my-[16px]">
                <label class="text-[#353535] font-bold-500 text-[14px] leading-[20px]">End Date</label>
                <input type="date" :max="maxDate"
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none focus:outline-none"
                  placeholder="Select a date" v-model="filter.dateEnd" />
              </div>
            </div>
            <div>
              <label class="text-[#353535] font-bold-500 text-[14px] leading-[20px]">Other filters</label>
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none focus:outline-none"
                  type="text" placeholder="Filter by distributor name" v-model="filter.qry" />
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[#96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button" data-dismiss="modal">
              Cancel
            </button>
            <button
              class="border-[#96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button" @click="reset">
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[#2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button" @click="getManufacturerTotalOrdersByStatusReport">
              {{ loading ? "Loading..." : "Search" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import Select2 from "@/components/Select2";
import { helper } from "@/helper";
import moment from "moment";
import Pagination from "../Pagination.vue";

export default {
  name: "ManufacturerTotalOrdersByStatusReport",
  components: {
    Select2,
    Pagination,
  },
  props: ["close"],
  created() {
    this.getManufacturerTotalOrdersByStatusReport();
  },
  data() {
    return {
      filter: {
        qry: "",
        dateStart: moment()
          .subtract(1, "years")
          .format("YYYY-MM-DD"),
        dateEnd: moment().format("YYYY-MM-DD"),
      },
      isBusy: false,
      loading: false,
      isBusyModal: false,
      isExportAllLoading: false,
      ReportItems: [],
      ExportReportItemsAll: [],
      isOrderByStatus: true,
      count: 0,
      page: 1,
      pageSize: 10,
      pageCount: 0,
      pageSizeExport: 99999999,
      hasNext: false,
      hasPrev: false,
      options: {
        format: "YYYY-MM-DD",
        icons: {
          time: "mdi mdi-time",
          date: "mdi mdi-calendar",
          up: "mdi mdi-chevron-up",
          down: "mdi mdi-chevron-down",
          previous: "mdi mdi-chevron-left",
          next: "mdi mdi-chevron-right",
          today: "mdi mdi-screenshot",
          clear: "mdi mdi-trash",
          close: "mdi mdi-remove",
        },
      },
      local: {
        dow: 0,
        hourTip: "Select Hour",
        minuteTip: "Select Minute",
        secondTip: "Select Second",
        yearSuffix: "",
        monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
          "_"
        ),
        months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weeks: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        cancelTip: "cancel",
        submitTip: "confirm",
      },
      maxDate: "",
      exportThreshold: 500,
    };
  },
  computed: {
    user() {
      return this.$store.state.currentUser;
    },
    csvData() {
      return this.exportItems.map((item) => ({
        ...item,
      }));
    },
    exportItems() {
      return this.ReportItems.map((item) => ({
        "Distributor Code": item.distributorCode,
        "Distributor Name": item.distributorName,
        "Orders Sum": `"${this.formatMoney(item.orderAmountSum)}"`,
        "Orders Count (Canceled)": item.orderCanceledCount,
        "Orders Count (Awaiting Approval)": item.orderPendingCount,
        "Orders Count (Processed)": item.orderFulfilledCount,
        "Orders Amount (Canceled)": `"${this.formatMoney(
          item.orderCanceledAmount
        )}"`,
        "Orders Amount (Awaiting Approval)": `"${this.formatMoney(
          item.orderPendingAmount
        )}"`,
        "Orders Amount (Processed)": `"${this.formatMoney(
          item.orderFulfilledAmount
        )}"`,
      }));
    },
    csvDataAll() {
      return this.exportItemsAll.map((item) => ({
        ...item,
      }));
    },
    exportItemsAll() {
      return this.ExportReportItemsAll.map((item) => ({
        "Distributor Code": item.distributorCode,
        "Distributor Name": item.distributorName,
        "Orders Sum": `"${this.formatMoney(item.orderAmountSum)}"`,
        "Orders Count (Canceled)": item.orderCanceledCount,
        "Orders Count (Awaiting Approval)": item.orderPendingCount,
        "Orders Count (Processed)": item.orderFulfilledCount,
        "Orders Amount (Canceled)": `"${this.formatMoney(
          item.orderCanceledAmount
        )}"`,
        "Orders Amount (Awaiting Approval)": `"${this.formatMoney(
          item.orderPendingAmount
        )}"`,
        "Orders Amount (Processed)": `"${this.formatMoney(
          item.orderFulfilledAmount
        )}"`,
      }));
    },
  },
  mounted() {
    this.maxDate = helper.preventFutureDateSelection();
  },
  methods: {
    reset() {
      this.page = 1;
      this.filter = {
        qry: "",
        dateStart: moment()
          .subtract(1, "years")
          .format("YYYY-MM-DD"),
        dateEnd: moment().format("YYYY-MM-DD"),
      };
    },
    viewFilter() {
      $("#mod-filter").modal("show");
    },
    async exportAllData() {
      if (this.count >= this.exportThreshold) {
        this.isExportAllLoading = true;
        try {
          await this.performRemoteExport("csv");
          return;
        } catch (error) {
          this.$toast.error("An error occurred while exporting all data.");
        } finally {
          this.isExportAllLoading = false;
        }
      }

      this.isExportAllLoading = true;
      try {
        if (!this.ExportReportItemsAll.length) {
          await this.getManufacturerTotalOrdersByStatusReportExportAllItems();
        }
        if (this.csvDataAll.length === 0) {
          return;
        }
        this.csvExport(this.csvDataAll);
      } catch (error) {
      } finally {
        this.isExportAllLoading = false;
      }
    },
    async performRemoteExport(fileType) {
      try {
        this.isBusy = true;
        const params = new URLSearchParams();
        params.append("fileType", fileType);

        if (this.filter.dateStart && moment(this.filter.dateStart).isValid()) {
          params.append(
            "startDate",
            moment(this.filter.dateStart).format("YYYY-MM-DD 00:00:00")
          );
        }
        if (this.filter.dateEnd && moment(this.filter.dateEnd).isValid()) {
          params.append(
            "endDate",
            moment(this.filter.dateEnd).format("YYYY-MM-DD 23:59:59")
          );
        }
        if (this.user.parentId) {
          params.append("parentId", this.user.parentId);
        }
        if (this.filter.qry) {
          params.append("query", this.filter.qry);
        }

        const url = `/Reports/exportTotalOrdersByStatusReport?${params.toString()}`;
        const res = await this.$http.post(url, {});
        const message =
          res.body && res.body.message
            ? res.body.message
            : "Report has been queued. Please check Queued Reports to access your report";
        this.$toast.success(message);
      } catch (error) {
        console.error("Error performing remote export:", error);
        this.$toast.error("An error occurred while initiating the export.");
      } finally {
        this.isBusy = false;
      }
    },
    getManufacturerTotalOrdersByStatusReportExportAllItems() {
      return new Promise((resolve, reject) => {
        this.isBusy = true;
        const url =
          "/Reports/getTotalOrdersByStatusReport?page=0" +
          "&pageSize=" +
          this.pageSizeExport +
          (this.filter.dateStart
            ? "&startDate=" +
            moment(this.filter.dateStart).format("YYYY-MM-DD 00:00:00")
            : "") +
          (this.filter.dateEnd
            ? "&endDate=" +
            moment(this.filter.dateEnd).format("YYYY-MM-DD 23:59:59")
            : "") +
          (this.user.parentId ? "&parentId=" + this.user.parentId : "") +
          (this.filter.qry ? "&query=" + this.filter.qry : "");
        this.$http
          .get(url)
          .then((res) => {
            const data = res.body && res.body.data ? res.body.data : [];
            this.ExportReportItemsAll = data;
            $("#mod-filter").modal("hide");
            this.isBusy = false;
            resolve(data);
          })
          .catch((err) => {
            $("#mod-filter").modal("hide");
            this.isBusy = false;
            reject(err);
          });
      });
    },
    getManufacturerTotalOrdersByStatusReport() {
      this.isBusy = true;
      this.loading = true;
      if (this.filter.qry) {
        this.page = 1;
      }
      const url =
        "/Reports/getTotalOrdersByStatusReport?page=" +
        (this.page - 1) +
        "&pageSize=" +
        this.pageSize +
        (this.filter.dateStart
          ? "&startDate=" +
          moment(this.filter.dateStart).format("YYYY-MM-DD 00:00:00")
          : "") +
        (this.filter.dateEnd
          ? "&endDate=" +
          moment(this.filter.dateEnd).format("YYYY-MM-DD 23:59:59")
          : "") +
        (this.user.parentId ? "&parentId=" + this.user.parentId : "") +
        (this.filter.qry ? "&query=" + this.filter.qry : "");
      this.$http
        .get(url)
        .then((res) => {
          this.ReportItems = res.body.data || [];
          this.page = res.body.page + 1;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count || 0;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize) || 0;
          this.hasPrev = res.body.hasPrev || false;
          this.hasNext = res.body.hasNext || false;
          $("#mod-filter").modal("hide");
          this.isBusy = false;
          this.loading = false;
        })
        .catch((err) => {
          $("#mod-filter").modal("hide");
          this.isBusy = false;
          this.loading = false;
        });
    },
    formatDate(date) {
      return moment(date).format("lll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    formatNumber(val) {
      return helper.formatNumber(val);
    },
    async csvExport(arrData) {
      if (!arrData.length) {
        alert("No data to export.");
        return;
      }

      if (this.count >= this.exportThreshold) {
        await this.performRemoteExport("csv");
        return;
      }

      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(arrData[0]).join(","),
        ...arrData.map((item) => Object.values(item).join(",")),
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "manufacturer_total_orders_by_status.csv");
      link.click();
    },
    prev() {
      if (this.page > 1) {
        this.page -= 1;
        this.getManufacturerTotalOrdersByStatusReport();
      }
    },
    next() {
      if (this.hasNext) {
        this.page += 1;
        this.getManufacturerTotalOrdersByStatusReport();
      }
    },
    gotoPage(page) {
      this.page = page;
      this.getManufacturerTotalOrdersByStatusReport();
    },
    changeLimit(limit) {
      this.pageSize = limit;
      this.page = 1;
      this.getManufacturerTotalOrdersByStatusReport();
    },
  },
};
</script>
